import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from '../../../../../../chronusStore/helper';
import ChrLink from '../../../../../generic/Utils/ChrLink';

const Stat = ({ initialCount, initialStatus, eventId , btnStatus}) => {
  const [count, setCount] = useState(initialCount);
  const currentRsvpStatus = useSelector(state => state.eventsListing.eventIdRsvpStatusMap[eventId]);
  const prevRsvpStatus = useRef(initialStatus);

  useEffect(() => {
    if(currentRsvpStatus === btnStatus && prevRsvpStatus.current !== btnStatus)
      setCount(prevCount => prevCount + 1);
    else if(currentRsvpStatus !== undefined && currentRsvpStatus !== btnStatus && prevRsvpStatus.current === btnStatus)
      setCount(prevCount => prevCount - 1)

    if(currentRsvpStatus !== undefined)
      prevRsvpStatus.current = currentRsvpStatus;
  }, [currentRsvpStatus]);

  return(count);
};

const InviteDetails = ({ inviteDetails, eventId }) => {
  return (
    <div className='d-flex row mr-1 mx-0'>
      { inviteDetails.map((inviteDetail, index) => (
        <div className={ `d-flex flex-column ${index !== 0 ? 'ml-4' : ''}` } key={ index }>
          <span className='font-600 my-2 h5'>{ inviteDetail.label }</span>
          <div className='d-flex flex-fill justify-content-center'>
            <ChrLink className='no-margins font-600 h3' href={ inviteDetail.url }>
              {
                inviteDetail.dynamicStat ? <Stat
                  initialCount={ inviteDetail.count }
                  initialStatus={ inviteDetail.initialStatus }
                  eventId={ eventId }
                  btnStatus={ inviteDetail.btnStatus }
                /> :
                inviteDetail.count
              }
            </ChrLink>
          </div>
        </div>
      ))
      }
    </div>
  )
};

export default InviteDetails;
